import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
	{
		path: '',
		canActivate: [MsalGuard],
		loadComponent: () => import('./components/my-requests/my-requests.component').then(m => m.MyRequestsComponent)
	},
	{
		path: 'my-requests',
		canActivate: [MsalGuard],
		loadComponent: () => import('./components/my-requests/my-requests.component').then(m => m.MyRequestsComponent)
	},
	{
		path: 'new-request',
		canActivate: [MsalGuard],
		loadComponent: () => import('./components/create-request/create-request.component').then(m => m.CreateRequestComponent)
	},
	{
		path: 'all-requests',
		canActivate: [MsalGuard],
		loadComponent: () => import('./components/all-requests/all-requests.component').then(m => m.AllRequestsComponent)
	},
	{
		path: 'edit-request',
		canActivate: [MsalGuard],
		loadComponent: () => import('./components/edit-request/edit-request.component').then(m => m.EditRequestComponent)
	},
	// ...add other routes here...
	{
		path: '**',
		redirectTo: '',
	}
];
